import styles from './Footer.module.scss';
import React, {useEffect, useRef} from "react";
import {Col, Row} from "react-bootstrap";
import Lottie, {LottieRefCurrentProps} from "lottie-react";
import animationData from "./hospital.json";


const Footer = () => {
    const animationRef = useRef<LottieRefCurrentProps>(null);

    useEffect(() => {
        if (animationRef.current) {
            animationRef.current.play();
        }
    }, []);

    return (
        <section className={styles.section}>
            <Row>
                <Col xs={4} className={styles.label}>
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        className={styles.animation}
                        lottieRef={animationRef}
                        style={{height: '75%', width: '75%'}}
                    />
                </Col>
                <Col xs={4}>
                    <h3 className={styles.label}>Навигатор</h3>
                    ...<br/>...<br/>...
                </Col>
                <Col xs={4}>
                    <h3 className={styles.label}>Информация</h3>
                    г. Верещагино, ул. К. Маркса, 64
                    <br/>
                    с 10:00 до 19:00
                    <br/>
                    понедельник-суббота
                    <br/>
                    <a href="tel:+79024777252">8 (902) 477 72-52</a>
                </Col>
                <Col xs={12} className="p-5">
                    <span className={styles.orgLabels}>©2026 ЗООДОКТОР, ветеринарная клиника</span>
                </Col>
            </Row>
        </section>
    );
};

export default Footer;